import React from 'react';
import { Popover } from '@milanote/roma';

import type { LabelsToolbarPopupProps } from '../labelComponentPropTypes';

type LabelsToolbarPopupFrameProps = Omit<LabelsToolbarPopupProps, 'currentUserId'> & {
    children: React.ReactNode;
};

/**
 * Shared desktop popup shell for element and task-item label pickers.
 */
const GenericLabelsToolbarPopup: React.FC<LabelsToolbarPopupFrameProps> = ({
    popupIsOpen = false,
    closePopup,
    triggerRef,
    children,
}) => {
    if (!triggerRef) return null;

    return (
        <Popover
            className="w-75"
            triggerRef={triggerRef}
            isOpen={popupIsOpen}
            onOpenChange={(isOpen) => {
                if (!isOpen) closePopup?.();
            }}
            placement="end top"
            offset={4}
            crossOffset={6}
            popoverClassName="LabelsPopup"
        >
            {children}
        </Popover>
    );
};

export default GenericLabelsToolbarPopup;
